import { h, ComponentChildren } from 'preact'

interface Props {
  id: string
  value: string | ComponentChildren
  label: string
  name: string
  isChecked: boolean
  onChange: () => void
  inputPosition?: 'left' | 'right'
}

interface RadioGroupProps {
  direction?: 'horizontal' | 'vertical'
  children: ComponentChildren
  spacing?: 'S' | 'M' | 'L'
}

export const RadioGroup = ({ children, direction = 'vertical', spacing = 'M' }: RadioGroupProps) => (
  <div className={` m-radio-${direction} m-radio_spacing-${spacing}`}>
    {children}
  </div>
)

const Radio = ({ value, name, id, isChecked, onChange, inputPosition = 'left' }: Props) => (
  <div className={`c-radio c-radio_position-${inputPosition}`}>
    <input type='radio' id={id} name={name} checked={isChecked} onChange={onChange} />
    <label for={id}>{value}</label>
  </div>
)

export default Radio
